/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {AutocompleteDefaultExample, AutocompleteNumbersExample, AutocompleteWithCustomTitle, AutocompleteDynamicallyUpdatedData, AutocompleteFirstFocusUpdate, AutocompleteToggleExample, AutocompletePredefinedInput, AutocompleteDifferentSizes, AutocompleteCustomWidth, AutocompleteSuffix, AutocompleteStatusExample} from 'Docs/uilib/components/autocomplete/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    ul: "ul",
    li: "li",
    code: "code",
    p: "p",
    a: "a",
    strong: "strong",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default autocomplete"
    }), "\n", _jsx(AutocompleteDefaultExample, {}), "\n", _jsx(_components.h3, {
      children: "Autocomplete with numbers"
    }), "\n", _jsx(AutocompleteNumbersExample, {}), "\n", _jsx(_components.h3, {
      children: "Autocomplete with a custom title"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "keep_value"
        }), " means the input value gets not removed after an input blur happens."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "show_clear_button"
        }), " means a clear button will show up when the input field contains a value."]
      }), "\n"]
    }), "\n", _jsx(AutocompleteWithCustomTitle, {}), "\n", _jsx(_components.h3, {
      children: "Async usage, dynamically update data during typing"
    }), "\n", _jsxs(_components.p, {
      children: ["This example simulates server delay with a timeout and - if it gets debounced, we cancel the timeout. Read more about the ", _jsx(_components.a, {
        href: "/uilib/components/autocomplete/events/#methods",
        children: "debounce method"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Also, you may consider using ", _jsx(_components.code, {
        children: "disable_filter"
      }), " if you have a backend doing the search operation."]
    }), "\n", _jsx(AutocompleteDynamicallyUpdatedData, {}), "\n", _jsx(_components.h3, {
      children: "Update data dynamically on the first focus"
    }), "\n", _jsx(AutocompleteFirstFocusUpdate, {}), "\n", _jsx(_components.h3, {
      children: "With a Button to toggle the open / close state"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " Just to show the possibility; the data is given as a function."]
    }), "\n", _jsx(AutocompleteToggleExample, {}), "\n", _jsx(_components.h3, {
      children: "With a predefined input/search value"
    }), "\n", _jsx(AutocompletePredefinedInput, {}), "\n", _jsx(_components.h3, {
      children: "Different sizes"
    }), "\n", _jsxs(_components.p, {
      children: ["Four sizes are available: ", _jsx(_components.code, {
        children: "small"
      }), ", ", _jsx(_components.code, {
        children: "default"
      }), ", ", _jsx(_components.code, {
        children: "medium"
      }), " and ", _jsx(_components.code, {
        children: "large"
      }), "."]
    }), "\n", _jsx(AutocompleteDifferentSizes, {}), "\n", _jsx(_components.h3, {
      children: "Data suffix value"
    }), "\n", _jsx(_components.p, {
      children: "Data is provided as such:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const { locale } = React.useContext(Context)\nconst data = [\n  {\n    suffix_value: (\n      <NumberFormat currency srLabel=\"Total:\" locale={locale}>\n        {12345678}\n      </NumberFormat>\n    ),\n    selected_value: `Brukskonto (${ban})`,\n    content: ['Brukskonto', ban],\n  },\n]\n"
      })
    }), "\n", _jsx(AutocompleteSuffix, {}), "\n", _jsx(_components.h3, {
      children: "Custom width"
    }), "\n", _jsx(AutocompleteCustomWidth, {}), "\n", _jsx(_components.h3, {
      children: "Autocomplete with status message"
    }), "\n", _jsx(AutocompleteStatusExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
